import { render, staticRenderFns } from "./CircleWave.vue?vue&type=template&id=24fbb50c&scoped=true&"
import script from "./CircleWave.vue?vue&type=script&lang=js&"
export * from "./CircleWave.vue?vue&type=script&lang=js&"
import style0 from "./CircleWave.vue?vue&type=style&index=0&id=24fbb50c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fbb50c",
  null
  
)

export default component.exports